export const configuration = {
  apiPath: "https://api.zelohub.com",
  apiEndpoint: "/api/",
};
